import { IDropdownOption } from '@fluentui/react';

import { Grouping } from '../../../telemetry/gen/ai/h2o/cloud/telemetry_read_api/v1/aiunits_pb';

export const groupByOptions: IDropdownOption[] = [
  {
    key: Grouping.WORKSPACE,
    text: 'Workspace',
  },
  {
    key: Grouping.USER,
    text: 'User',
  },
  {
    key: Grouping.SERVICE,
    text: 'Service',
  },
  {
    key: Grouping.TAG,
    text: 'Tag',
  },
];
